<template>
  <div :class="$style['games-title']">
    <IconGamepad />
    <span>{{ t("home.mini_games.title") }}</span>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
</script>

<style lang="scss" module>
.games-title {
  display: flex;
  font-size: 48px;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: -0.48px;
  align-items: center;
  gap: 16px;
  svg {
    width: 56px;
    height: 56px;
  }
}
</style>
